import base from './base'

export default {
  ...base,
  colors: {
    ...base.colors,
    shadow1: '#000',
    text1: '#FFFFFF',
    text2: '#FFFFFF',
    text3: '#FFFFFF',
    text4: '#FFFFFF',

    // backgrounds / greys
    bg0: '#17113a',
    bg1: '#00c2cb',
    bg2: '#00c2cb',
    bg3: '#17113a',
    bg4: '#00c2cb',
    bg5: '#17113a',

    //specialty colors
    modalBG: 'rgba(0,0,0,.425)',
    advancedBG: 'rgba(0,0,0,0.1)',

    //primary colors
    primary1: '#24c7d6',
    primary4: '#376bad70',
    primary5: '#153d6f70',

    // color text
    primaryText1: '#6da8ff',
    buttonText: '#ffffff',

    // secondary colors
    secondary1: '#24c7d6'
  }
}
